<template>
   <div style="width: 100%; height: 100%;">
      <div class="custom-container">
         <v-row no-gutters justify="center">
            <v-col cols="12" md="8">
               <v-card flat>
                  <v-card-title class="headline">
                     Idee anlegen
                  </v-card-title>
               </v-card>
               <v-card flat>
                  <v-card-text>
                     <v-text-field label="Titel" v-model="idea.title" outlined/>
                     <v-textarea label="Beschreibung" v-model="idea.description" outlined/>
                     <v-select :items="categories" item-value="id" item-text="name" v-model="idea.ideas_category_id"
                               label="Kategorie" prepend-inner-icon="mdi-shape" outlined/>
                  </v-card-text>
                  <v-card-text>
                     <v-row dense>
                        <v-col cols="12" md="auto">
                           <v-btn color="error" outlined @click="cancel">Abbrechen</v-btn>
                        </v-col>
                        <v-col cols="12" md="auto">
                           <v-btn color="success" depressed @click="$route.params.id ? updateIdea() : postIdea()">Speichern</v-btn>
                        </v-col>
                     </v-row>
                  </v-card-text>
               </v-card>
            </v-col>
         </v-row>
      </div>
   </div>
</template>

<script>
import {mapActions} from 'vuex';

export default {
   props: [],
   name: "",
   data: () => ({
      idea: {
         ideas_category_id: '',
      },
      categories: [],
   }),
   computed: {},
   created() {
      if (this.$route.query.id) {
         this.idea.ideas_category_id = this.$route.query.id;
      }
      this.getCategories()
      if (this.$route.params.id) {
         this.showIdea();
      }
   },
   methods: {
      ...mapActions({}),
      getCategories() {
         this.axios.get('/ideas-categories').then((r) => {
            this.categories = Object.values({...r.data.data});
         })
      },
      cancel() {
         this.$router.push({name: 'IdeasWorkbenchDashboard'})
      },
      postIdea() {
         this.axios.post('/ideas', {
            'idea': this.idea
         }).then((r) => {
            this.$toast.success('Die Idee wurde erfolgreich angelegt.');
            this.$router.push({name: 'IdeasWorkbenchIdeasShow', params: {id: r.data.id}});
         })
      },
      showIdea() {
         this.axios.get('/ideas/' + this.$route.params.id).then((r) => {
            this.idea = r.data.data;
         }).catch(() => {
            this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
         })
      },
      updateIdea(){
         this.axios.patch('/ideas/'+ this.$route.params.id, {
            'idea': this.idea
         }).then((r) => {
            this.$toast.success('Die Idee wurde erfolgreich aktualisiert.');
            this.$router.push({name: 'IdeasWorkbenchIdeasShow', params: {id: r.data.id}});
         }).catch(() => {
            this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
         })
      }
   },
}
</script>

<style scoped>

</style>
